import Container from './Container'

Container.install = (Vue, options) => {
  Vue.component(Container.name, Container)
}
export default Container


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/components/Container/index.js
// module id = null
// module chunks = 